<template>
    <router-view
        :is-loading="isLoading"
        :setups="setups"
        :key="$route.fullPath"
    ></router-view>
</template>
<script>
    import apiSetups from '../api/apiSetups';
    
    export default {
        name: 'Setup',
        data() {
            return {
                setups: [],
                isLoading: true,
            };
        },
        created() {
            this.getSetups();
        },
        methods: {
            getSetups() {
                this.isLoading = true;
                apiSetups.getSetups().then((res) => {
                    this.setups = res.data;
                    this.isLoading = false;
                }).catch(() => {
                    this.$toastr.longError('Api error');
                });
            },
        },
    };
</script>


<style
    lang="scss"
    scoped
>
    
    .setup {
        .return-button {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 500px;
            
            &_icon {
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                width: 20px;
                height: 20px;
                margin-top: -5px;
                margin-left: 30px;
                margin-right: 15px;
            }
        }
        
        &-wrapper {
            display: flex;
            max-width: 275px;
            justify-content: space-between;
            margin-left: 10px;
            margin-top: 5px;
            
            &_title {
                display: flex;
                min-width: 64px;
                align-items: center;
                padding-top: 5px;
                color: red;
            }
            
            &-scheme {
                font-weight: 700;
            }
            
        }
        
        .setup-wrapper_error {
            ::v-deep {
                input {
                    border-color: red;
                }
            }
        }
        
        &-wrapper__button {
            display: flex;
            flex-direction: row-reverse;
        }
        
        &-current {
            margin: 26px 26px 26px 26px;
        }
        
        &-table {
            
            border-radius: 10px;
            @include dark-shadow;
            max-width: 567px;
            margin: 26px 26px 26px 0;
            
            &-header {
                display: flex;
                height: 45px;
                border-bottom: 1px solid #6089E7;
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 20%;
                }
                
                &-title {
                    text-align: center;
                    margin-top: 23px;
                    font-family: Poppins;
                    height: 12px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 12px;
                    width: 180px;
                    
                }
                
                &-title__long {
                    width: 27px;
                }
            }
            
            &-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                min-height: 45px;
                border-top: 1px solid rgba(96, 137, 231, 0.2);
                @media (max-width: 927px) {
                    padding-left: 5px;
                    padding-right: 2%;
                }
                
                &-shell {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    
                    &-text {
                        font-family: Quicksand;
                        color: #000F48;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 18px;
                        width: 180px;
                        text-align: center;
                        @media (max-width: 927px) {
                            font-size: 12px;
                        }
                    }
                    
                    &__img {
                        width: 180px;
                        
                        img {
                            width: 40px;
                            height: 40px;
                            background-size: contain;
                            background-repeat: no-repeat;
                        }
                    }
                    
                    &-scheme {
                        display: flex;
                        flex-direction: column;
                        width: 180px;
                        
                        &-text {
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
                
                &-close-icon {
                    display: flex;
                    float: right;
                    width: 17px;
                    height: 17px;
                    padding-right: 10px;
                    background-repeat: no-repeat;
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                    cursor: pointer;
                }
            }
        }
        
        &-table__scheme {
            max-width: 387px;
        }
    }
</style>